import React from 'react';

import Banner from './';

const PrepToolBanner = () => (
  <Banner
    titleTranslationKey={'prep-tool.banner.title'}
    subtitleTranslationKey={'prep-tool.banner.subtitle'}
    classes={'banner--small banner--no-mobile'}
    localImagesFolderName={'prep-tools'}
  />
);

export default PrepToolBanner;
